<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div
				v-if="bannerList.length > 0"
				class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="3000" :show-indicators="true" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img
								class="bg"
								data-aos="fade-in"
								data-aos-duration="400"
								data-aos-delay="100"
								data-aos-offset="0"
								data-aos-once="true"
								:src=" weburl + value.image"
							/>
							<div v-if="index == 0" class="msg_box">
								<div class="tit"
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="400"
									data-aos-offset="0"
									data-aos-once="true"
								>{{ value.title }}</div>
								<div class="txt"
									data-aos="fade-up"
									data-aos-duration="400"
									data-aos-delay="800"
									data-aos-offset="0"
									data-aos-once="true"
								>{{ value.miaoshu }}</div>
								<div v-if="value.url != '/' && value.url != ''" class="btn_box"
									data-aos="fade-in"
									data-aos-duration="400"
									data-aos-delay="1000"
									data-aos-offset="0"
									data-aos-once="true"
								>
									<van-button color="#E37542" class="btn_el" @click="goBanner(value)">LEARN MORE</van-button>
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<div v-else style="height: 100vh;text-align: center;line-height: 80vh;">
				<van-image src="">
				  <template v-slot:loading>
				    <van-loading type="spinner" size="20" />
				  </template>
				</van-image>
			</div>
			<!--banner-->
			<!--Search-->
			<div class="search_box">
				<div class="search_main"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit">SEARCH PRODUCTS</div>
					<div class="search_box_el">
						<input v-model="inputVal" class="input_el" placeholder="Search by Name, or Keyword" @keyup.enter="goProducts('search')" />
						<van-icon name="search" class="icon" size="30" color="#ffffff" @click="goProducts('search')" />
					</div>
				</div>
			</div>
			<!--Search-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_el">
					<img src="../../assets/img_h5/index/block_1.webp"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					/>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Antibodies</div>
						<div class="txt">
							Our extensive portfolio includes hybridoma or recombinant monoclonal and polyclonal antibodies for immunological applications.
						</div>
						<div class="btn_box" style="color: #E37542;" @click="goProducts(productType[0].id)">
							Explore Antibodies&nbsp;<van-icon name="down" class="icon" size="17" color="#E37542" />
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<img src="../../assets/img_h5/index/block_2.webp"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					/>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="tit">Antigens</div>
						<div class="txt">
							The reliable antigen reagents are specifically crafted to meet the demands of a variety of assay technologies.
						</div>
						<div class="btn_box" style="color: #006BB3;" @click="goProducts(productType[1].id)">
							Explore Antigens&nbsp;<van-icon name="down" class="icon" size="17" color="#006BB3" />
						</div>
					</div>
				</div>
				<div class="bot_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div class="left"></div>
						<div class="center">
							<div class="title">UC reagent i-Membrane</div>
							<div class="tit">UC reagent I-MEMBRANE</div>
						</div>
						<div class="right"></div>
					</div>
					<div class="text">
						i-Membrane is an industry leading partner to diagnostic manufacturers worldwide. We ensure a reliable supply of components and customizable services including membrane card development for IVD rapid testing applications.
					</div>
					<div class="btn_box" @click="goIm">
						Learn More&nbsp;<van-icon name="down" class="icon" size="17" color="#E37542" />
					</div>
					<div class="img_box">
						<img src="../../assets/img_h5/index/block_3.webp" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div v-if="false" class="block_2">
				<div class="top_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="tit_box">
						<div class="left"></div>
						<div class="center">
							<div class="title">CLIA Lab Testing</div>
							<div class="tit">CLIA LAB TESTING</div>
						</div>
						<div class="right"></div>
					</div>
					<div class="text">
						Jtests Clinical Laboratory specializing in RT-PCR-based tests. Alongside, we offer comprehensive blood and urinary analysis, prioritizing molecular diagnostics. 
					</div>
					<div class="btn_box" @click="goIm">
						Explore&nbsp;<van-icon name="down" class="icon" size="17" color="#E37542" />
					</div>
					<div class="list_box">
						<div class="list_el" @click="goServices">
							<img class="img" src="../../assets/img_h5/index/block_4.webp" />
							<div class="title">
								Rapid Test Services
							</div>
						</div>
						<div class="list_el" @click="goServices">
							<img class="img" src="../../assets/img_h5/index/block_5.webp" />
							<div class="title">
								Urinary Analysis for Infectious Diseases
							</div>
						</div>
						<div class="list_el" @click="goServices">
							<img class="img" src="../../assets/img_h5/index/block_6.webp" />
							<div class="title">
								Blood Routine Testing
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3"
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="left"></div>
					<div class="center">
						<div class="title">News & Events</div>
						<div class="tit">NEWS & EVENTS</div>
					</div>
					<div class="right"></div>
				</div>
				<div v-if="newsList.length > 0" class="list_box">
					<div v-for="(value, index) in newsList" :key="index" class="list_el" @click="goNewsInfo(value)">
						<div class="img_box">
							<van-image class="img_el" width="100%" height="auto" :src="weburl + value.image" fit="cover" />
						</div>
						<div class="tit">{{ value.title }}</div>
					</div>
				</div>
				<div class="all">
					<div class="btn_box" @click="goNews">
						ALL&nbsp;<van-icon name="down" class="icon" size="17" color="#ffffff" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { UPURL } from '@/util/util.js';
import { bannerList } from '@/api/public';
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			productType: [],
			inputVal: '',
			newsList: [],
			weburl: '',
			bannerList: [],
			isRload: true,
		}
	},
	created(){
		let that = this;
		that.weburl = UPURL;
		if(sessionStorage.getItem('navData')) {
			that.newsList = JSON.parse(sessionStorage.getItem('navData')).news_list;
			that.productType = JSON.parse(sessionStorage.getItem('navData')).cate_list;
		}
		//轮播图
		bannerList({ leixing: 2 }).then(res => {
			that.bannerList = res.data;
		});
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		bannerChange() {
			let that = this;
			that.isRload = false;
			setTimeout(() => {
				that.isRload = true;
			}, 400);
		},
		goBanner(value) {
			window.location.href = value.url;
		},
		//跳转产品中心
		goProducts(type) {
			let that = this;
			switch(type) {
				case 1:
					that.$router.push({ path: '/products', query: { type: 1 } });
				break;
				case 2:
					that.$router.push({ path: '/products', query: { type: 2 } });
				break;
				case 'search':
					if(that.inputVal) {
						that.$router.push({ path: '/products', query: { search: that.inputVal } });
					}else {
						that.$toast('Please enter name, keywords or catalog number to search.');
					}
				break;
				default:
					that.$router.push({ path: '/products' });
			}
		},
		goNewsInfo(value) {
			let that = this;
			if(value.custom) {
				let routeData = that.$router.resolve({name: "newsInfo", params: { newsId: value.custom } });
				window.location.href = routeData.href, '_blank';
			}else {
				that.$toast('Parameter exception, unable to obtain detailed information.');
			}
		},
		goNews() {
			this.$router.push({ path: '/news' });
		},
		goServices() {
			let that = this;
			// that.$router.push({ path: '/services' });
		},
		goIm() {
			window.location.href = 'https://i-membrane.com/';
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #000000;
	font-size: 14px;
	//块3
	.block_3{
		background: url(../../assets/img_h5/index/block_7.webp) no-repeat 100% 100%;
		background-size: cover;
		padding: 50px 20px;
		.all{
			padding-top: 30px;
			text-align: center;
			.btn_box{
				color: #ffffff;
				font-size: 18px;
				.icon{
					top: 3px;
					transform: rotate(-90deg);
				}
			}
		}
		.list_box{
			.list_el{
				padding-top: 30px;
				.img_el{
					border-radius: 6px;
					overflow: hidden;
				}
				.tit{
					padding-top: 5px;
					color: #ffffff;
					font-size: 16px;
				}
			}
		}
		.tit_box{
			display: flex;
			align-items: center;
			.center{
				flex: 1;
				text-align: center;
				.tit{
					font-size: 18px;
					color: #CCCCCC;
				}
				.title{
					font-size: 24px;
					color: #ffffff;
				}
			}
			.left, .right{
				width: 40px;
				height: 1px;
				background-color: #CCCCCC;
			}
		}
	}
	//块2
	.block_2{
		.top_box{
			padding: 50px 20px 50px 20px;
			.list_box{
				padding-top: 20px;
				.list_el{
					display: flex;
					align-items: center;
					padding-top: 20px;
					.title{
						flex: 1;
						color: #006BB3;
						padding-left: 20px;
					}
					.img{
						width: 80px;
					}
				}
			}
			.btn_box{
				color: #E37542;
				font-size: 16px;
				.icon{
					top: 4px;
					transform: rotate(-90deg);
				}
			}
			.text{
				padding: 15px 0 10px 0;
				font-size: 16px;
			}
			.tit_box{
				display: flex;
				align-items: center;
				.center{
					flex: 1;
					text-align: center;
					.tit{
						font-size: 18px;
						color: #CCCCCC;
					}
					.title{
						font-size: 24px;
					}
				}
				.left, .right{
					width: 40px;
					height: 1px;
					background-color: #CCCCCC;
				}
			}
		}
	}
	//块1
	.block_1{
		.bot_box{
			padding: 50px 20px 50px 20px;
			.img_box{
				padding-top: 30px;
				img{
					width: 100%;
				}
			}
			.btn_box{
				color: #E37542;
				font-size: 16px;
				.icon{
					top: 4px;
					transform: rotate(-90deg);
				}
			}
			.text{
				padding: 15px 0 10px 0;
				font-size: 16px;
			}
			.tit_box{
				display: flex;
				align-items: center;
				.center{
					flex: 1;
					text-align: center;
					.tit{
						font-size: 18px;
						color: #CCCCCC;
					}
					.title{
						font-size: 24px;
					}
				}
				.left, .right{
					width: 40px;
					height: 1px;
					background-color: #CCCCCC;
				}
			}
		}
		.block_1_el{
			position: relative;
			.msg_box{
				width: 100%;
				position: absolute;
				top: 50%;
				left: 0;
				transform: translate(0, -50%);
				padding: 0 20px;
				text-align: center;
				.btn_box{
					padding-top: 30px;
					font-size: 16px;
					text-decoration: underline;
					.icon{
						top: 4px;
						transform: rotate(-145deg);
					}
				}
				.txt{
					padding-top: 5px;
					font-size: 16px;
					color: #ffffff;
				}
				.tit{
					font-size: 36px;
					color: #ffffff;
				}
			}
			img{
				width: 100%;
			}
		}
	}
	//搜索
	.search_box{
		width: 100%;
		margin: 0 auto;
		padding: 25px 20px 40px 20px;
		background-color: #006BB3;
		.search_main{
			width: auto;
			text-align: center;
			.tit{
				padding-bottom: 10px;
				font-size: 32px;
				color: #E37542;
			}
			.search_box_el{
				display: flex;
				align-items: center;
				.icon{
					margin-left: 15px;
				}
				.input_el{
					flex: 1;
					height: 40px;
					padding-top: 6px;
					line-height: 40px;
					text-align: center;
					font-size: 18px;
					color: #006BB3;
					border-radius: 6px;
					border: none;
					background-color: #ffffff;
				}
			}
		}
	}
	//banner
	.banner_box{
		width: 100%;
		position: relative;
		.swipe_box{
			.swiper_el{
				.msg_box{
					width: 100%;
					margin: 0 auto;
					padding: 0 30px;
					position: absolute;
					top: 45px;
					left: 50%;
					transform: translate(-50%, 0);
					.btn_box{
						margin-top: 20px;
						.btn_el{
							height: auto;
							padding: 6px 12px 2px 12px;
							font-size: 18px;
							border-radius: 6px;
						}
					}
					.txt{
						padding-top: 5px;
						font-size: 16px;
					}
					.tit{
						font-size: 32px;
						font-weight: bold;
						span{
							font-size: 14px;
							color: #A20073;
						}
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>